import ComparisonCardSkeleton from './ComparisonCardSkeleton';
import ComparisonChartSkeleton from './ComparisonChartSkeleton';
import ComparisonPerformanceTableSkeleton from './ComparisonPerformanceTableSkeleton';

const ComparisonResultsPageSkeleton = () => (
  <div
    className="flex flex-col gap-4 text-foreground"
    aria-busy="true"
    aria-label="Loading comparison"
  >
    <ComparisonPerformanceTableSkeleton rows={3} columns={10} />
    <ComparisonChartSkeleton />
    <div className="grid grid-cols-1 gap-4 min-[960px]:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]">
      <ComparisonCardSkeleton title="Positions diff" lines={6} />
      <ComparisonCardSkeleton title="Allocation overlap" lines={5} />
    </div>
    <ComparisonCardSkeleton title="Winners & losers" lines={8} />
  </div>
);

export default ComparisonResultsPageSkeleton;
